import { ArrowUpDown } from 'lucide-react';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '@/components/ui/select';
import type { SortBy } from '@/lib/sortProducts';

interface SortSelectProps {
  value: SortBy;
  onChange: (value: SortBy) => void;
  className?: string;
}

export function SortSelect({ value, onChange, className }: SortSelectProps) {
  return (
    <div className={`flex items-center gap-2 ${className ?? ''}`}>
      <ArrowUpDown className="h-4 w-4 text-muted-foreground flex-shrink-0" />
      <Select value={value} onValueChange={(v) => onChange(v as SortBy)}>
        <SelectTrigger className="w-[160px] h-9 text-sm">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="sku">Art.nr (A–Ö)</SelectItem>
          <SelectItem value="name">Produktnamn (A–Ö)</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
